import React from 'react';
import { X, Star, ExternalLink, Calendar, MapPin, Tag } from 'lucide-react';

const ReviewDetailModal = ({ review, onClose }) => {
  if (!review) return null;

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('da-DK');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal review-detail-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '900px' }}>
        <div className="modal-header">
          <div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '8px'
            }}>
              <span className={`badge badge-${review.type}`}>
                {review.type}
              </span>
              <div className="rating">
                <Star size={16} fill="#ffd700" color="#ffd700" />
                {review.rating}/10
              </div>
            </div>
            <h2 className="modal-title" style={{ marginBottom: '8px' }}>
              {review.title}
            </h2>
            <p style={{
              fontSize: '1.3rem',
              color: 'var(--text-secondary)',
              fontWeight: '500'
            }}>
              {review.artist}
            </p>
          </div>
          <button onClick={onClose} className="close-btn">
            <X size={24} />
          </button>
        </div>

        {/* Image */}
        {review.image_url && (
          <div style={{
            width: '100%',
            height: '300px',
            borderRadius: '16px',
            overflow: 'hidden',
            marginBottom: '24px'
          }}>
            <img
              src={review.image_url}
              alt={review.title}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </div>
        )}

        {/* Meta Information */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          marginBottom: '24px',
          fontSize: '14px',
          color: 'var(--text-muted)',
          flexWrap: 'wrap'
        }}>
          {review.release_date && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Calendar size={16} />
              <span>Udgivet: {formatDate(review.release_date)}</span>
            </div>
          )}
          {review.concert_date && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Calendar size={16} />
              <span>Koncert: {formatDate(review.concert_date)}</span>
            </div>
          )}
          {review.venue && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <MapPin size={16} />
              <span>{review.venue}</span>
            </div>
          )}
        </div>

        {/* Tags */}
        {review.tags && review.tags.length > 0 && (
          <div style={{ marginBottom: '24px' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginBottom: '12px'
            }}>
              <Tag size={16} color="var(--text-muted)" />
              <span style={{
                fontSize: '14px',
                color: 'var(--text-muted)',
                textTransform: 'uppercase',
                fontWeight: '600',
                letterSpacing: '0.5px'
              }}>
                Tags
              </span>
            </div>
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '8px'
            }}>
              {review.tags.map((tag, index) => (
                <span
                  key={index}
                  style={{
                    background: 'var(--primary-gradient)',
                    color: 'white',
                    padding: '6px 14px',
                    borderRadius: '16px',
                    fontSize: '12px',
                    fontWeight: '600'
                  }}
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Full Review Text */}
        <div style={{
          marginBottom: '32px',
          lineHeight: '1.8',
          color: 'var(--text-primary)'
        }}>
          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            marginBottom: '16px',
            color: 'var(--text-primary)'
          }}>
            Anmeldelse
          </h3>
          <div style={{
            background: 'rgba(255, 255, 255, 0.02)',
            padding: '24px',
            borderRadius: '12px',
            border: '1px solid rgba(255, 255, 255, 0.05)'
          }}>
            {review.review_text.split('\n').map((paragraph, index) => (
              <p key={index} style={{ 
                marginBottom: '16px',
                fontSize: '1rem',
                lineHeight: '1.7'
              }}>
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        {/* Action Links */}
        <div style={{
          display: 'flex',
          gap: '16px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          {review.listen_link && (
            <a
              href={review.listen_link}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                textDecoration: 'none'
              }}
            >
              <ExternalLink size={18} />
              {review.type === 'album' ? 'Lyt til album' : 'Mere info'}
            </a>
          )}
          {review.ticket_link && (
            <a
              href={review.ticket_link}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                textDecoration: 'none'
              }}
            >
              <ExternalLink size={18} />
              Køb billetter
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReviewDetailModal;
